/* eslint-disable id-length */
import {
    type EventTypeTyping,
    type GuestTypeTyping,
    type ProductCategoryTyping,
    type ProductTyping,
    type SpaceTyping,
    type VenueTyping,
    type WidgetPartTyping,
} from '@/typings/widget';
import { type ComputedRef, type Ref } from 'vue';

// eslint-disable-next-line max-statements, max-lines-per-function
export const useWidgetVenueStore = defineStore('venue', () => {
    // State
    const venue: Ref<VenueTyping | null> = ref(null);
    const venueId: Ref<string> = ref('');
    const venueAgentId: Ref<string> = ref('');
    const venueSpaces: Ref<SpaceTyping[]> = ref([]);
    const venueGuestTypes: Ref<GuestTypeTyping[]> = ref([]);
    const venueProductCategories: Ref<ProductCategoryTyping[]> = ref([]);
    const venueProducts: Ref<ProductTyping[]> = ref([]);
    const venueWidgetParts: Ref<WidgetPartTyping[]> = ref([]);
    const openWindow: Ref<boolean> = ref(false);

    // Getters
    const venueEventTypes: ComputedRef<EventTypeTyping[]> = computed(() =>
        [...(venue.value?.eventTypes ?? [])].sort((eventA, eventB) =>
            eventA.name.localeCompare(eventB.name)));
    const filteredVenueProductCategories: ComputedRef<ProductCategoryTyping[]> = computed(() => venueProductCategories.value.filter(category => ![
        7, 8, 10,
    ].includes(category.id)));
    const isDigitalHostActive: ComputedRef<boolean> = computed(() => Boolean(venueWidgetParts.value.find(part => part.widgetPartId === 2)?.activated));
    const isMakeSelfQuoteActive: ComputedRef<boolean> = computed(() => Boolean(venueWidgetParts.value.find(part => part.widgetPartId === 3)?.activated));
    const isPackageActive: ComputedRef<boolean> = computed(() => Boolean(venueWidgetParts.value.find(part => part.widgetPartId === 4)?.activated));
    const isContactActive: ComputedRef<boolean> = computed(() => Boolean(venueWidgetParts.value.find(part => part.widgetPartId === 5)?.activated));
    const isAppointmentActive: ComputedRef<boolean> = computed(() => Boolean(venueWidgetParts.value.find(part => part.widgetPartId === 6)?.activated));

    return {
        venue,
        venueId,
        venueAgentId,
        venueSpaces,
        venueGuestTypes,
        venueProductCategories,
        venueProducts,
        venueWidgetParts,
        venueEventTypes,
        openWindow,
        filteredVenueProductCategories,
        isDigitalHostActive,
        isMakeSelfQuoteActive,
        isPackageActive,
        isContactActive,
        isAppointmentActive,
    };
});
